import { WearableIneligibleLinesReason } from 'journey/productDetails/typings';

// CART_WEARABLE_THRESHOLD_REACHED and HAS_NO_LINES has temporary message. Need to update after the appropriate message will be finalize in figma.
const MESSAGE = {
  PREPAID_LINE: `Prepaid plans are not eligible for interest free payment (IFP). Please choose a plan that's eligible for IFP or contact us to change your plan.`,
  INCOMPATIBLE_PLAN: `This plan isn’t eligible for use with wearables. Please choose a plan that's eligible or contact us to change your plan.`,
  CART_WEARABLE_THRESHOLD_REACHED:
    'Sorry, you can only buy one watch at a time.',
  APPLE_WEARABLE_MAXIMUM_NUMBER_REACHED: `You already have the maximum of two wearable plans connected to this line. To buy this watch, you'll need to go back and buy the device without a plan or Interest Free Payment (IFP).`,
  HAS_NO_LINES:
    'You currently have no plans that are eligible for wearables. Please choose a new plan that is eligible for wearables or contact us for more information.',
};

type WearableIneligibleLinesMessage = keyof typeof MESSAGE;

export const isIncompatiblePlanCheck = (
  reason: WearableIneligibleLinesReason,
): boolean => {
  return !(
    reason === 'PREPAID_LINE' ||
    reason === 'APPLE_WEARABLE_MAXIMUM_NUMBER_REACHED' ||
    reason === 'CART_WEARABLE_THRESHOLD_REACHED'
  );
};

interface GetWarningMessageParameter {
  hasLines: boolean;
  reason: WearableIneligibleLinesReason;
}

export const getWarningMessage = ({
  hasLines,
  reason,
}: GetWarningMessageParameter) => {
  if (!hasLines) {
    return MESSAGE.HAS_NO_LINES;
  }
  if (isIncompatiblePlanCheck(reason)) {
    return MESSAGE.INCOMPATIBLE_PLAN;
  }
  return MESSAGE[reason as WearableIneligibleLinesMessage];
};
